/* eslint-disable */
import { denyRouteAccess } from "../routerHelpers";

const usersManagementRoutes = [
  {
    path: "users-management",
    name: "UsersManagement",
    meta: {
      title: "Users Management | Portal",
    },
    component: () => import("../../views/UsersManagement/Index.vue"),
    beforeEnter: (to, from, next) => {
      denyRouteAccess(to, next);
    },
  },
];

export default usersManagementRoutes;
